import { Injectable } from '@angular/core';
import {ApiClass} from "../../../class/api-class";
import {map} from "rxjs";
import {IFlow} from "../../../interfaces/iflow.interface";
import {IWeetrustDocument} from "../../../interfaces/iweetrusth.interface";
import {environment} from "../../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ApiFlowDataService extends ApiClass {

  constructor() {
    super()
    this.path = 'flowData'
  }

  saveInfo(data: any) {
    return this.postCollection(data, 'form').pipe(map((r) => r as {error: boolean, msg: string; data: IFlow}))
  }

  uploadDocument(data: any) {
    return this.postCollection(data, 'document').pipe(map((r) => r as {error: boolean, msg: string; data: IFlow}))
  }

  getIneValidationUrl(data: any) {
    return this.postCollection(data, 'ineValidationUrl').pipe(map((r) => r as {error: boolean, msg: string; data: {url: string;sessionStatus: string, stageId: string}}))
  }

  getAccountValidationUrl(workerId: string) {
    const previousPath = this.path;
    this.path = 'app-domiciliation/generateLink';

    const request = this.postCollection({ workerId }, '', environment.apiDomiciliation).pipe(
      map((r) => r as {
        error: boolean,
        msg: string,
        data: {
          url: string;
          sessionStatus: string;
          stageId: string;
        }
      })
    );

    this.path = previousPath;

    return request;
  }

  connectAccount(body: { workerId: string; accountNumber: string }) {
    const prev = this.path;
    this.path = 'app-domiciliation/connectAccount';
    const res = this.postCollection({ data: body }, '', environment.apiDomiciliation).pipe(
      map(r => r as {
        error: boolean,
        msg: string,
        data: {
          slug?: string,
          account_uuid?: string
        }
      })
    );
    this.path = prev;
    return res;
  }

  authenticateAccount(body: { account_uuid: string, slug: string, otp: number }) {
    const prev = this.path;
    this.path = 'app-domiciliation/authenticeAccount';
    const res = this.postCollection(body, '', environment.apiDomiciliation).pipe(
      map(r => r as {
        error: boolean,
        msg: string,
        data: any
      })
    );
    this.path = prev;
    return res;
  }

  updateSessionStatusAndStage(workerId: string, properties: {}, clabe: string) {
    const previousPath = this.path;
    this.path = 'app-domiciliation/update-session';

    const request = this.postCollection(
      { workerId, properties, clabe },
      '',
      environment.apiDomiciliation
    ).pipe(
      map((r) => r as {
        error: boolean,
        msg: string,
        data: {
          workerId: string;
        }
      })
    );

    this.path = previousPath;

    return request;
  }



  validateIneValidationStatus(data: any) {
    return this.postCollection(data, 'ineValidationStatus').pipe(map((r) => r as {error: boolean, msg: string; data: IFlow}))
  }

  validateExternalUrl(data: any) {
    return this.postCollection(data, 'external').pipe(map((r) => r as {error: boolean, msg: string; data: IFlow}))
  }

  getWeetrustDocument(data: any) {
    return this.postCollection(data, 'documentSign').pipe(map((r) => r as {error: boolean, msg: string; data: {
      weetrustDocument: IWeetrustDocument,
      status: string;
      stageId: string;
    }}))
  }

  getOffers(data: any) {
    return this.postCollection(data, 'getOffers').pipe(map((r) => r as {
      error: boolean; msg: string; data: {stageId: string; loanProperties: {
          loanStatusEnabled: boolean;
          loanAmountAllowed: number;
          loanRate: number;
          period: string;
          minAmount: number;
        }}
    }))
  }

  calculateOffers(data: any) {
    return this.postCollection(data, 'calculateOffers').pipe(map((r) => r as {
      error: boolean; msg: string; data: {stageId: string; offers: {installmentCount: number; installmentAmount: number}[]}
    }))
  }

  applyOffers(data: any) {
    return this.postCollection(data, 'applyOffer').pipe(map((r) => r as {
      error: boolean; msg: string; data: {stageId: string;}
    }))
  }

}
